import { createWorkCalendarHolidayPredicate } from '@srm/ui/lib/workCalendar';
import { loadWorkCalendar } from '@utils/workCalendar';

/**
 * Не-хуковый поставщик проверки выходного дня для resolver.
 * Использует общие с `useWorkCalendar` загрузку, кэш и предикат, поэтому два слоя
 * не расходятся в поведении и не отправляют дублирующие запросы календаря.
 */
export function createWorkCalendarHolidayChecker(): () => Promise<(date: Date) => boolean> {
    return async () => createWorkCalendarHolidayPredicate(await loadWorkCalendar());
}
